module.exports = __webpack_public_path__ + "images/nodata-screenshots/agenda.gif";